import Breadcrumb from "components/Common/Breadcrumb"
import QwikForm from "components/form/QwikForm"
import QwikInput from "components/form/QwikInput"
import React, { useState } from "react"
import { Col, Container, Row, FormGroup, Label } from "reactstrap"
import { toast } from "sonner"
import hashPassword from "utils/hashPassword"
import QwikSelect from "components/form/QwikSelect"
import { useCreateClientMutation } from "store/features/client/clientManagementApi"
import { useCreateUserMutation } from "store/features/users/userManagementApi"
import { useNavigate } from "react-router-dom"

const CreateClient = () => {
  const [createUser, { isLoading: creatingUser }] = useCreateUserMutation()
  const [createClient, { isLoading: creatingClient }] =
    useCreateClientMutation()
  const navigate = useNavigate()

  const [profileImage, setProfileImage] = useState(null)

  const handleSubmit = async data => {
    try {
      // Step 1: Create User
      const userData = {
        role: "client",
        phone: data.phone,

        client_name: data.nickname,
        client_email: data.personal_email,
        gender: data.gender || "",

        company_name: data.company_name,
        company_website: null,
        contact_person: data.contact_person,
        contact_number: data.phone,
        address: data.address,
        notes: data.additional_info || "",
      }

      const createdClient = await createClient(userData).unwrap()

      // Create FormData for user if image exists
      // let createdUser

      // if (profileImage) {
      //   const userFormData = new FormData()
      //   Object.keys(userData).forEach(key => {
      //     userFormData.append(key, userData[key])
      //   })
      //   userFormData.append("image", profileImage)
      //   createdUser = await createUser(userFormData).unwrap()
      // } else {
      //   createdUser = await createUser(userData).unwrap()
      // }

      if (createdClient?.id) {
        toast.success("Client created successfully!")

        // Reset form
        setProfileImage(null)

        setTimeout(() => {
          navigate("/all-clients")
        }, 2000)
      } else {
        toast.error("Failed to create user account")
      }
    } catch (error) {
      console.error("Client creation error:", error)
      toast.error("Failed to create client. Please try again.")
    }
  }

  const handleImageChange = event => {
    const file = event.target.files[0]
    setProfileImage(file)
  }

  const getFileName = file => {
    return file ? file.name : "No file chosen"
  }

  const isLoading = creatingUser || creatingClient

  return (
    <div className="page-content">
      <Container fluid={true}>
        <Breadcrumb title="Clients" breadcrumbItem="Add Client" />
        <Row>
          <QwikForm onSubmit={handleSubmit}>
            <Col className="col-12">
              <Row>
                {/* Company Information */}
                {/* <Col lg={12}>
                  <h5 className="mb-3 border-bottom pb-2">
                    Company Information
                  </h5>
                </Col> */}
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="nickname"
                      label="Name"
                      placeholder="Enter your name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="personal_email"
                      label="Email"
                      placeholder="Enter email address"
                      type="email"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="phone"
                      label="Phone Number"
                      placeholder="Enter phone number"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikSelect
                      name="gender"
                      label="Gender"
                      options={[
                        { value: "male", label: "Male" },
                        { value: "female", label: "Female" },
                        { value: "other", label: "Other" },
                      ]}
                    />
                  </div>
                </Col>

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="password"
                      label="Password"
                      placeholder="Enter password"
                      type="password"
                      className="form-control"
                      required
                    />
                  </div>
                </Col> */}

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="address"
                      label="Address"
                      placeholder="Enter full address"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>

                {/* Contact Information */}
                {/* <Col lg={12}>
                  <h5 className="mb-3 border-bottom pb-2">
                    Contact Information
                  </h5>
                </Col> */}
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="company_name"
                      label="Company Name"
                      placeholder="Enter company name"
                      type="text"
                      className="form-control"
                      required
                    />
                  </div>
                </Col>
                {/* Additional Information */}
                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="additional_info"
                      label="Additional Information"
                      placeholder="Enter any additional information about the client"
                      type="textarea"
                      className="form-control"
                      rows="3"
                    />
                  </div>
                </Col>

                <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="contact_person"
                      label="Contact Person"
                      placeholder="Enter contact person name"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col>
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="official_email"
                      label="Official Email (Optional)"
                      placeholder="Enter official email"
                      type="email"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="confirm_password"
                      label="Confirm Password"
                      placeholder="Confirm password"
                      type="password"
                      className="form-control"
                      required
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="emp_id"
                      label="Employee ID (Optional)"
                      placeholder="Enter employee ID"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="date_of_birth"
                      label="Date of Birth"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="position"
                      label="Position"
                      placeholder="Enter position"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="experience_years"
                      label="Experience (Years)"
                      placeholder="Enter years of experience"
                      type="number"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="blood_group"
                      label="Blood Group"
                      placeholder="Enter blood group"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="joining_date"
                      label="Joining Date"
                      type="date"
                      className="form-control"
                    />
                  </div>
                </Col> */}
                {/* <Col lg={6}>
                  <div className="mb-3">
                    <QwikInput
                      name="city"
                      label="City"
                      placeholder="Enter city"
                      type="text"
                      className="form-control"
                    />
                  </div>
                </Col> */}

                {/* Address */}

                {/* Profile Image Upload */}
                {/* <Col lg={6}>
                  <FormGroup>
                    <Label for="profile_image" className="form-label">
                      Profile Image
                    </Label>
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="profile_image"
                        accept=".jpg,.jpeg,.png,.gif"
                        onChange={handleImageChange}
                      />
                    </div>
                  </FormGroup>
                </Col> */}

                <div className="col-sm-6 text-start mt-3">
                  <button
                    className="btn btn-primary w-md waves-effect waves-light"
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? "Creating Client..." : "Create Client"}
                  </button>
                </div>
              </Row>
            </Col>
          </QwikForm>
        </Row>
      </Container>
    </div>
  )
}

export default CreateClient
